var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 37,
    viewBox: "0 0 33 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.5463 5.59813V31.037C31.5402 32.106 31.1572 33.129 30.4805 33.8841C29.8039 34.6391 28.8882 35.0652 27.9323 35.0698H5.5672C4.60996 35.0652 3.69309 34.6379 3.01621 33.881C2.33933 33.1241 1.95724 32.0987 1.95312 31.0283V5.59813C1.95519 4.52464 2.33745 3.49578 3.01624 2.7367C3.69503 1.97763 4.61507 1.55016 5.57503 1.54785H27.9323",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5852 3.55964C32.0173 3.55964 32.3675 3.16798 32.3675 2.68485C32.3675 2.20172 32.0173 1.81006 31.5852 1.81006C31.1532 1.81006 30.803 2.20172 30.803 2.68485C30.803 3.16798 31.1532 3.55964 31.5852 3.55964Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7197 15.0205H18.6311V16.4551H18.7093C19.2099 15.5804 20.0392 14.7056 22.0809 14.7056C24.6076 14.7056 26.4929 16.5689 26.4929 20.6279V28.8072H22.6598V21.1703C22.6598 19.4207 22.1043 18.1785 20.7197 18.1785C20.2856 18.1824 19.8638 18.3404 19.5151 18.6297C19.1664 18.919 18.9089 19.3246 18.7797 19.7881C18.6951 20.1354 18.666 20.4967 18.6937 20.8553V28.8159H14.8605V18.4497",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8097 18.5192V28.9292H7.98438V15.02H11.8097",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.06 10.3573C12.0631 10.8373 11.9387 11.3075 11.7025 11.7083C11.4663 12.1091 11.1289 12.4224 10.7333 12.6085C10.3376 12.7946 9.90144 12.8451 9.48008 12.7536C9.05872 12.662 8.67116 12.4326 8.36655 12.0945C8.06194 11.7563 7.854 11.3246 7.76911 10.854C7.68423 10.3835 7.72622 9.89541 7.88975 9.45161C8.05329 9.00781 8.33101 8.62833 8.68768 8.36128C9.04435 8.09424 9.46391 7.95167 9.89315 7.95166",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.12afa483441d8fbc7a644cf398fd3f5c.svg";
export { ForwardRef as ReactComponent };